import axios from 'axios'
import config from '../../config'
const BASE_URL = config.API_V1

export default class ApiRequest {
  constructor(options = {}) {
    this.client = null
    this.api_url = BASE_URL
    this.auth_token = config.auth_token
    if (options.useWindowLocation) {
      this.api_url = window.location.origin + '/api'
    }
  }
  init = (params) => {
    const localStorageKeys = Object.keys(window.context)
    let headers = {
      Accept: 'application/json',
      locationorigin: window.location.origin,
      auth_token: this.auth_token,
      'content-type': 'application/json; charset=utf-8',
    }
    localStorageKeys.forEach((key) => {
      if (key.indexOf('context') !== -1) {
        const context = window.context[key]
        headers[key] = `${context}`
      }
    })
    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 120000,
      headers: headers,
      params,
    })
    return this.client
  }

  async get(endPoint, params) {
    const res = await this.init(params ? params : {}).get(endPoint)
    return res
  }

  async post(endPoint, data) {
    const res = await this.init().post(endPoint, data)
    return res
  }

  async put(endPoint, data) {
    const res = await this.init().put(endPoint, data)
    return res
  }

  async delete(endPoint) {
    const res = await this.init().delete(endPoint)
    return res
  }
}
export class ApiRequestPrivate {
  constructor() {
    this.client = null
    this.api_url = BASE_URL
    this.auth_token = config.auth_token
  }
  init = (params) => {
    let headers = {
      Accept: 'application/json',
      locationorigin: window.location.origin,
      auth_token: this.auth_token,
      'content-type': 'application/json; charset=utf-8',
    }

    this.client = axios.create({
      baseURL: this.api_url,
      timeout: 31000,
      headers: headers,
      params,
      withCredentials: true,
    })
    return this.client
  }

  async get(endPoint, params) {
    const res = await this.init(params ? params : {}).get(endPoint)
    return res
  }

  async post(endPoint, data) {
    const res = await this.init().post(endPoint, data)
    return res
  }

  async put(endPoint, data) {
    const res = await this.init().put(endPoint, data)
    return res
  }

  async delete(endPoint) {
    const res = await this.init().delete(endPoint)
    return res
  }
}
